// src/pages/admin/AdminLogin.js
import React, { useState } from 'react';
import axios from 'axios';
// react-router-dom v6의 useNavigate 훅을 사용합니다.
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // useNavigate 훅을 사용하여 페이지 이동 함수를 가져옵니다.
  const navigate = useNavigate();

  // 환경 변수에서 백엔드 URL을 가져옵니다. 없으면 기본값을 사용합니다.
  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:3001";

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); // 이전 에러 메시지 초기화

    // 사용자 이름과 비밀번호를 Base64로 인코딩합니다.
    const credentials = btoa(`${username}:${password}`);
    const authHeader = `Basic ${credentials}`;

    try {
      // 관리자 API(예: /api/admin/status)를 호출하여 자격 증명을 확인합니다.
      // 인증 헤더를 포함하여 요청을 보냅니다.
      await axios.get(`${baseURL}/api/admin/status`, {
        headers: { 'Authorization': authHeader }
      });

      // 인증 성공 시:
      // 1. 인증 헤더를 sessionStorage에 저장합니다.
      sessionStorage.setItem('authHeader', authHeader);
      // 2. axios의 기본 헤더를 설정합니다. (선택 사항: AdminDashboard에서도 설정하므로 중복될 수 있음)
      axios.defaults.headers.common['Authorization'] = authHeader;
      // 3. 관리자 대시보드 페이지('/admin')로 이동합니다.
      navigate('/admin');

    } catch (err) {
      // 인증 실패 또는 기타 오류 발생 시:
      console.error('로그인 에러:', err);
      if (err.response && err.response.status === 401) {
        setError('잘못된 사용자 이름 또는 비밀번호입니다.');
      } else {
        setError('로그인 중 오류가 발생했습니다. 서버 상태를 확인하세요.');
      }
      // 실패 시 sessionStorage에서 이전 헤더를 제거하는 것이 안전합니다.
      sessionStorage.removeItem('authHeader');
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 p-4">
      <div className="w-full max-w-sm"> {/* 최대 너비 설정 */}
        <form onSubmit={handleLogin} className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">관리자 로그인</h2>
          {error && <p className="text-red-500 text-sm mb-4 text-center">{error}</p>}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
              사용자 이름
            </label>
            <input
              id="username"
              type="text"
              placeholder="사용자 이름 입력"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              비밀번호
            </label>
            <input
              id="password"
              type="password"
              placeholder="비밀번호 입력"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
              required
            />
          </div>
          <div className="flex items-center justify-center">
            <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300">
              로그인
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
